import halo from "../../assets/images/logo-halo.png";
import { PageShell } from "../../components/PageShell/PageShell";
import { JoinByLink } from "./JoinByLink";
import styles from "./Home.module.css";

export const Home = () => (
  <PageShell>
    <section className={styles.hero}>
      <img src={halo} alt="" className={styles.halo} />
      <h1 className={styles.title}>Join a meeting</h1>
      <p className={styles.text}>PQChat Rooms calls are end-to-end encrypted. A host admits each guest from the lobby.</p>
      <div className={`card ${styles.joinCard}`}>
        <JoinByLink />
      </div>
    </section>
  </PageShell>
);
